import { ibkApi } from '@ibk/shared-config';
import { blobToBase64 } from './contractOrderPaymentApi';
export async function parseOrderReceiptPdfResponse(response) {
    if (!response.ok) {
        return response.json();
    }
    if (!response.headers.get('content-type')?.toLowerCase().startsWith('application/pdf')) {
        throw new Error('Invalid payment receipt content type');
    }
    const blob = await response.blob();
    const bytes = new Uint8Array(await blob.arrayBuffer());
    const tail = String.fromCodePoint(...bytes.subarray(Math.max(0, bytes.length - 1024)));
    if (String.fromCodePoint(...bytes.subarray(0, 5)) !== '%PDF-' || !tail.includes('%%EOF')) {
        throw new Error('Invalid payment receipt PDF');
    }
    const disposition = response.headers.get('content-disposition') ?? '';
    const encodedName = /filename\*=UTF-8''([^;]+)/i.exec(disposition)?.[1];
    const name = /filename="([^"]+)"/i.exec(disposition)?.[1] ?? /filename=([^;]+)/i.exec(disposition)?.[1]?.trim();
    let filename = name ?? null;
    if (encodedName) {
        try {
            filename = decodeURIComponent(encodedName);
        }
        catch {
            filename = name ?? null;
        }
    }
    return { base64: await blobToBase64(blob), filename };
}
export const buildGenerateOrderReceiptPdfMutation = ({ contractId, orderId, }) => ({
    url: `/v1/benefits/contracts/${contractId}/orders/${orderId}/payment-receipt/pdf`,
    method: 'POST',
    responseHandler: parseOrderReceiptPdfResponse,
});
export const contractOrderReceiptApi = ibkApi.injectEndpoints({
    endpoints: build => ({
        generateEmissorOrderReceiptPdf: build.mutation({
            query: buildGenerateOrderReceiptPdfMutation,
        }),
    }),
    overrideExisting: false,
});
export const { useGenerateEmissorOrderReceiptPdfMutation } = contractOrderReceiptApi;
